import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { Button, Typography } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import SendIcon from "@mui/icons-material/Send";
import GraphemeSplitter from "grapheme-splitter";
import Colors from "./Colors";
import axios from "axios";
import { API_URL } from "./Constant";

const EnterAnswerAudioBackend = ({
  highlightedBox,
  allQuestions,
  setHighlightedBox,
  setUserAnswer,
  setAllGridData,
  allGridData,
  setCurrentQuestionIndex,
  currentQuestionIndex,
}) => {
  const [grid, setGrid] = useState([]);
  const [answerInput, setAnswerInput] = useState([]);
  const [updateSuccess, setUpdateSuccess] = useState("");
  const [activeField, setActiveField] = useState(null);
  const [listening, setListening] = useState(false);
  const [wrongAttempts, setWrongAttempts] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const swaraksharam = [
    "അ",
    "ആ",
    "ഇ",
    "ഈ",
    "ഉ",
    "ഊ",
    "ഋ",
    "എ",
    "ഏ",
    "ഐ",
    "ഒ",
    "ഓ",
    "ഔ",
    "അം",
    "അഃ",
  ];
  const vyanjanaksharam = [
    "ക",
    "ഖ",
    "ഗ",
    "ഘ",
    "ങ",
    "ച",
    "ഛ",
    "ജ",
    "ഝ",
    "ഞ",
    "ട",
    "ഠ",
    "ഡ",
    "ഢ",
    "ണ",
    "ത",
    "ഥ",
    "ദ",
    "ധ",
    "ന",
    "പ",
    "ഫ",
    "ബ",
    "ഭ",
    "മ",
    "യ",
    "ര",
    "ല",
    "വ",
    "ശ",
    "ഷ",
    "സ",
    "ഹ",
    "ള",
    "ഴ",
    "റ",
  ];
  const chinnangal = [
    "ാ",
    "ി",
    "ീ",
    "ു",
    "ൂ",
    "ൃ",
    "െ",
    "േ",
    "ൈ",
    "ൊ",
    "ോ",
    "ൗ",
    "ം",
    "ഃ",
    "്",
    "്യ",
    "്ര",
    "്വ",
  ];
  const kootaksharam = [
    "ക്ക",
    "ഗ്ഗ",
    "ങ്ങ",
    "ച്ച",
    "ജ്ജ",
    "ഞ്ഞ",
    "ട്ട",
    "ഡ്ഡ",
    "ണ്ണ",
    "ത്ത",
    "ദ്ദ",
    "ന്ന",
    "പ്പ",
    "ബ്ബ",
    "മ്മ",
    "യ്യ",
    "ല്ല",
    "വ്വ",
    "ശ്ശ",
    "സ്സ",
    "ളള",
    "ങ്ക",
    "ഗ്ന",
    "ഗ്മ",
    "ഞ്ച",
    "ണ്മ",
    "ണ്ട",
    "ണ്ഡ",
    "ന്മ",
    "ന്ത",
    "ന്ദ",
    "ത്മ",
    "മ്പ",
    "ഹ്ന",
    "ഹ്മ",
    "ക്ഷ",
    "ജ്ഞ",
    "ശ്ച",
    "ത്ഥ",
    "ത്ഭ",
    "ത്സ",
    "സ്ഥ",
    "സ്റ്റ",
    "ന്ധ",
    "ദ്ധ",
    "ക്സ",
    "സ്മ",
    "സ്ക",
    "സ്പ",
    "ഞ്ച",
    "ണ്ട",
    "ന്ത",
    "മ്പ",
    "ൻ്റ",
  ];
  const chillaksharam = ["ൽ", "ൾ", "ൻ", "ർ", "ൺ"];

  const generateAllValidLetters = () => {
    const allValidLetters = new Set([
      ...swaraksharam,
      ...vyanjanaksharam,
      ...kootaksharam,
      ...chillaksharam,
    ]);

    // Limit the number of combinations with chinnangal
    const maxCombinations = 20; // Adjust this number as needed
    const selectedCombinations = new Set();

    while (selectedCombinations.size < maxCombinations) {
      const base = [...vyanjanaksharam, ...kootaksharam][
        Math.floor(
          Math.random() * (vyanjanaksharam.length + kootaksharam.length),
        )
      ];
      const chin = chinnangal[Math.floor(Math.random() * chinnangal.length)];
      selectedCombinations.add(base + chin);
    }

    // Add limited combinations to allValidLetters
    for (const combo of selectedCombinations) {
      allValidLetters.add(combo);
    }

    return Array.from(allValidLetters);
  };

  const allValidLetters = generateAllValidLetters();

  useEffect(() => {
    setAnswerInput(Array.from({ length: highlightedBox.length }, () => ""));
    setActiveIndex(0);
  }, [highlightedBox]);

  useEffect(() => {
    if (updateSuccess === "wrong" && !localStorage.getItem("RapidGame")) {
      setWrongAttempts((prev) => {
        const newAttempts = prev + 1;
        if (newAttempts > 2) {
          localStorage.setItem("PointReduce", "True");
        }

        if (newAttempts > 4) {
          setShowAnswer(true);
        }

        return newAttempts;
      });
    }
  }, [updateSuccess]);

  useEffect(() => {
    console.log("Current wrongAttempts:", wrongAttempts);
  }, [wrongAttempts]);

  // Reset when user starts typing a new answer
  useEffect(() => {
    if (highlightedBox.answer_options) {
      console.log("Resetting wrongAttempts due to new input.");
      setWrongAttempts(0);
      setShowAnswer(false);
    }
  }, [highlightedBox.answer_options]);

  useEffect(() => {
    if (highlightedBox.answer_options) {
      // Remove `{}` and `"` and split by comma
      const cleanedString = highlightedBox.answer_options.replace(/[{}"]/g, "");
      const parsedOptions = cleanedString.split(",");

      // Convert into a 2D array (e.g., 4 columns per row)
      const numColumns = 7; // Adjust based on your layout
      const structuredGrid = [];

      for (let i = 0; i < parsedOptions.length; i += numColumns) {
        structuredGrid.push(parsedOptions.slice(i, i + numColumns));
      }

      // Ensure the last element of the last row is '⌫'
      if (structuredGrid.length > 0) {
        let lastRow = structuredGrid[structuredGrid.length - 1];

        // If the last row is full, create a new row for '⌫'
        if (lastRow.length === numColumns) {
          structuredGrid.push(["⌫"]);
        } else {
          lastRow.push("⌫");
        }
      } else {
        structuredGrid.push(["⌫"]); // If no letters, just add '⌫'
      }

      console.log(structuredGrid); // Debug: Check final grid structure
      setGrid(structuredGrid);
    }
  }, [highlightedBox]);

  //  useEffect(() => {
  //     if (!highlightedBox || !highlightedBox.answer) return;
  //     setActiveField(null)
  //    // setUpdateSuccess('');
  //     const answer = highlightedBox.answer;
  //     const answerLetters = answer.split(',');
  //     const answerLength = answerLetters.length;
  //     // Initialize the answer input with blank fields
  //     const initialInputs = Array(answerLength).fill('');

  //     // Find the start position and direction
  //     const { question_number, direction } = highlightedBox;
  //     let startRow, startCol;

  //     // Locate the starting cell for the highlighted question
  //     allGridData.forEach((row, rowIndex) => {
  //       row.forEach((cell, colIndex) => {
  //         if (cell.value === question_number.toString()) {
  //           startRow = rowIndex;
  //           startCol = colIndex;
  //         }
  //       });
  //     });

  //     if (startRow !== undefined && startCol !== undefined) {
  //       // Update the answer input with pre-filled letters from allGridData
  //       for (let i = 0; i < answerLength; i++) {
  //         const row = direction === 'across' ? startRow : startRow + i;
  //         const col = direction === 'across' ? startCol + i : startCol;

  //         const gridCell = allGridData[row]?.[col];
  //         if (gridCell?.answer) {
  //           initialInputs[i] = gridCell.answer;
  //         }
  //       }
  //     }

  //     setAnswerInput(initialInputs);

  //     const totalButtons = 14; // 13 letters + 1 backspace button
  //     const lettersNeeded = totalButtons - 1;

  //     // Generate unique random letters
  //     const generateUniqueRandomLetters = (num, excludeLetters) => {
  //       const availableLetters = allValidLetters.filter((letter) => !excludeLetters.includes(letter));
  //       const uniqueRandomLetters = new Set();

  //       while (uniqueRandomLetters.size < num && uniqueRandomLetters.size < availableLetters.length) {
  //         const randomIndex = Math.floor(Math.random() * availableLetters.length);
  //         uniqueRandomLetters.add(availableLetters[randomIndex]);
  //       }

  //       return Array.from(uniqueRandomLetters);
  //     };

  //     const letterPool = Array.from(new Set([...answerLetters])); // Ensure unique answer letters
  //     const remainingLetters = generateUniqueRandomLetters(lettersNeeded - answerLetters.length, letterPool);
  //   console.log("lettersNeeded",lettersNeeded - answerLetters.length)
  //     // Combine the letters (answer letters + remaining letters)
  //     const combinedLetters = [...letterPool, ...remainingLetters];

  //     // Shuffle the combined letters
  //     const shuffledGridItems = combinedLetters.sort(() => Math.random() - 0.5);

  //     // Add Backspace button as the last item
  //     shuffledGridItems.push('⌫');

  //     // Organize the shuffled grid items into rows (2D grid)
  //     const rows = [];
  //     for (let i = 0; i < Math.ceil(totalButtons / 7); i++) {
  //       rows.push(shuffledGridItems.slice(i * 7, i * 7 + 7));
  //     }

  //   setGrid(highlightedBox.answer_options);

  // }, [highlightedBox, allGridData]);

  const handleFieldClick = (index) => {
    setActiveField(index); // Set the clicked field as active
  };

  const handleGridClick = async (letter) => {
    setUpdateSuccess("");
    const updatedInputs = [...answerInput];
    const firstEmptyIndex = updatedInputs.findIndex((input) => input === "");

    // If an empty index is found, set the letter there
    if (firstEmptyIndex !== -1) {
      updatedInputs[firstEmptyIndex] = letter;
      setAnswerInput(updatedInputs);
      setActiveIndex(firstEmptyIndex);
      const filledLetterCount = updatedInputs.filter(
        (input) => input !== "",
      ).length;

      // Check if the length of the answer input is the same as the length of the highlighted box answer
      if (filledLetterCount === highlightedBox.length) {
        try {
          const response = await axios.post(`${API_URL}/validate-answer`, {
            creatorId: localStorage.getItem("selectedCreator"),
            gameId: localStorage.getItem("gameId"),
            questionNumber: highlightedBox.question_number,
            userAnswer: updatedInputs,
          });

          console.log(response.data);
          // Handle the response from the backend
          if (response.data.isCorrect) {
            setUpdateSuccess("correct");

            console.log("Correct answer!");
          } else {
            setUpdateSuccess("wrong");
            console.log("Incorrect answer!");
          }
        } catch (error) {
          console.error("Error validating answer:", error);
        }
      }
    }
  };
  useEffect(() => {
    setUpdateSuccess("");
  }, [currentQuestionIndex]);

  useEffect(() => {
    if (updateSuccess === "correct") {
      setUserAnswer(answerInput);
      setCurrentQuestionIndex((prev) => prev + 1);
    }
  }, [updateSuccess]);

  const handleBackspaceClick = () => {
    const updatedInputs = [...answerInput];

    // Remove the letter at the active index
    updatedInputs[activeIndex] = "";
    setAnswerInput(updatedInputs);

    // Move the active index to the left if possible
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const handleMicClick = async () => {
    if (
      !("SpeechRecognition" in window || "webkitSpeechRecognition" in window)
    ) {
      alert("Speech recognition is not supported in your browser.");
      return;
    }

    setListening(true);

    const recognition = new (window.SpeechRecognition ||
      window.webkitSpeechRecognition)();
    recognition.lang = "ml-IN";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.start();

    recognition.onresult = async (event) => {
      let spokenText = event.results[0][0].transcript
        .trim()
        .replace(/\s+/g, "");

      // Get available letters from highlightedBox
      const availableLetters = highlightedBox.answer_options || [];

      let spokenArray = [];
      let tempStr = "";

      for (let i = 0; i < spokenText.length; i++) {
        tempStr += spokenText[i];

        // Check if tempStr + next char is a valid letter from availableLetters
        if (i + 1 < spokenText.length) {
          let nextStr = tempStr + spokenText[i + 1];

          if (availableLetters.includes(nextStr)) {
            tempStr = nextStr; // Extend tempStr if valid combination found
            i++; // Skip the next character as it is now part of tempStr
          }
        }

        // If tempStr is in availableLetters, add it to spokenArray
        if (availableLetters.includes(tempStr)) {
          spokenArray.push(tempStr);
          tempStr = ""; // Reset for next grouping
        }
      }

      // Push any remaining characters
      if (tempStr) {
        spokenArray.push(tempStr);
      }

      console.log("spokenText:", spokenText);
      console.log("spokenArray before filtering:", spokenArray);

      setAnswerInput(spokenArray);

      if (spokenArray.length > 0) {
        try {
          const response = await axios.post(`${API_URL}/validate-answer`, {
            creatorId: localStorage.getItem("selectedCreator"),
            gameId: localStorage.getItem("gameId"),
            questionNumber: highlightedBox.question_number,
            userAnswer: spokenArray,
          });

          if (response.data.isCorrect) {
            setUpdateSuccess("correct");
            setUserAnswer(spokenArray);
            console.log("Correct answer!");
          } else {
            setUpdateSuccess("wrong");
            console.log("Incorrect answer!");
          }
        } catch (error) {
          console.error("Error validating answer:", error);
        }
      }

      setListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setListening(false);
    };

    recognition.onend = () => setListening(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        alignItems: "center",
        width: "100%",
        marginBottom: "36px",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {Array.from({ length: highlightedBox.length }).map((_, index) => (
          <Box
            key={index}
            sx={{
              borderRadius: "8px",
              backgroundColor:
                updateSuccess === "correct"
                  ? "#90c581" // Light Green for Correct
                  : updateSuccess === "wrong"
                    ? "#F4BFBF" // Light Red for Wrong
                    : Colors.button2, // Default Blue
              color:
                updateSuccess === "correct" || updateSuccess === "wrong"
                  ? "#000"
                  : "#000",
              textAlign: "center",
              fontWeight: 600,
              fontSize: "12px",
              height: "44px",
              width: "44px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid",
              borderColor:
                updateSuccess === "correct"
                  ? "#388E3C"
                  : updateSuccess === "wrong"
                    ? "#FF7070"
                    : Colors.button2Border,
              "&:hover": {
                backgroundColor: Colors.button2,
                color: "#fff", // Optional: Adjust text color for better contrast
              },
              "&:focus": {
                backgroundColor: Colors.button2,
                color: "#fff", // Optional: Adjust text color for better contrast
                outline: "none", // Optional: Remove the default focus outline
              },
            }}
            onClick={() => setActiveIndex(index)}
          >
            {answerInput[index]}
          </Box>
        ))}
      </Box>

      {showAnswer && (
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: { xs: "14px", md: "16px" },
            lineHeight: "24px",
            color: "#202f75",
            textAlign: "center",
            zIndex: 1,
            marginTop: { xs: "-10%", md: "-2%" },
            fontFamily: "Roboto",
          }}
        >
          ഉത്തരം: {highlightedBox.answer}
        </Typography>
      )}

      <Button
        onClick={handleMicClick}
        sx={{
          background: listening ? "#beb1de" : "#999798", // Listening effect color change
          color: "#000",
          borderRadius: "50%",
          height: "48px",
          width: "48px",
          padding: "0",
          minWidth: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          animation: listening
            ? "pulse 1s infinite" // Apply pulse animation when listening is true
            : "none", // No animation when not listening
          "&:hover": {
            background: Colors.micGrey,
          },
          "@keyframes pulse": {
            "0%": {
              transform: "scale(1)",
            },
            "50%": {
              transform: "scale(1.2)", // Scale up to 1.2x
            },
            "100%": {
              transform: "scale(1)", // Return to original size
            },
          },
        }}
      >
        <MicIcon style={{ width: "24px", height: "24px" }} />
      </Button>

      {grid.map((row, rowIndex) => (
        <Box
          key={rowIndex}
          sx={{
            display: "flex",
            gap: "4px",
            width: "100%",
            maxWidth: "352px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {console.log(grid)}
          {row.map((letter, cellIndex) => {
            const isPartOfAnswer = highlightedBox?.answer
              ?.split(",")
              .includes(letter);
            const shouldHighlightGreen =
              isPartOfAnswer && updateSuccess === "wrong" && wrongAttempts >= 2; // Highlight if two wrong attempts

            return (
              <Box
                key={cellIndex}
                sx={{
                  width: "44px",
                  height: "44px",
                  backgroundColor: shouldHighlightGreen
                    ? "#A5D6A7"
                    : Colors.keybordKey, // Always blue unless two wrong attempts
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  fontSize: "10px",
                  fontFamily: "Roboto",
                  fontWeight: "bold",
                  color: Colors.keybordfont,
                  border: shouldHighlightGreen
                    ? "2px solid #388E3C"
                    : "1px solid #451952",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (letter === "⌫") {
                    handleBackspaceClick();
                  } else {
                    handleGridClick(letter);
                  }
                }}
              >
                {letter === "⌫" ? (
                  <BackspaceIcon style={{ width: "20px", height: "20px" }} />
                ) : (
                  letter
                )}
              </Box>
            );
          })}
        </Box>
      ))}

      <Box
        sx={{ display: "flex", justifyContent: "center", gap: "16px", mt: 3 }}
      >
        <Button
          onClick={() => {
            setAnswerInput(Array(highlightedBox.length).fill("")); // Clear all inputs
            setUpdateSuccess(""); // Reset updateSuccess state
          }}
          sx={{
            background: Colors.button2,
            color: Colors.button2font,
            width: "120px",
            border: "1px solid ",
            borderColor: Colors.button2Border,
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "12px",
            transition: "background 0.3s, transform 0.3s",
            "&:hover": {
              background: Colors.button2,
              transform: "scale(1.05)",
            },
            "&:active": {
              background: Colors.button2,
            },
          }}
        >
          Clear All
        </Button>
        <Button
          onClick={() => window.location.reload()}
          sx={{
            background: Colors.button1,
            color: Colors.button1font,
            width: "120px",
            border: "1px solid ",
            borderColor: Colors.button1Border,
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "12px",
            transition: "background 0.3s, transform 0.3s",
            "&:hover": {
              background: Colors.button1,
              transform: "scale(1.05)",
            },
            "&:active": {
              background: Colors.button1,
            },
          }}
        >
          Quit
        </Button>
      </Box>
    </Box>
  );
};

export default EnterAnswerAudioBackend;
